<template>
  <div
    class="modal fade show d-block"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    data-test="examination-detail-modal"
  >
    <div
      class="modal-dialog wide-modal modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-body py-2 flex-grow-1">
          <div v-if="!data && loading" class="small">Loading…</div>
          <div v-else-if="!data && error" class="text-danger small">
            {{ error }}
          </div>
          <div v-else class="small">
            <ExaminationHeader :examination="data" />
            <ExaminationMediaTable
              :media="data.media || []"
              :expanded="expanded"
              @toggle="toggle"
            />
            <ExaminationCaseDataBox v-if="data" :examination-id="data.id" />
            <ExaminationManifestBox :manifest="data.manifest" />
          </div>
        </div>
        <div class="modal-footer py-2 justify-content-start sticky-footer">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="loading"
            @click="refresh"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            <span v-if="loading">Refreshing…</span>
            <span v-else>Refresh</span>
          </button>
          <button
            type="button"
            class="btn btn-secondary me-2"
            @click="$emit('close')"
          >
            Close
          </button>
        </div>
      </div>
    </div>
    <teleport to="body">
      <div class="modal-backdrop fade show"></div>
    </teleport>
  </div>
</template>

<script>
import { practitionerHttpService } from "../../../../app/practitioner-portal/store/practitioner-http-service";
import ExaminationHeader from "./ExaminationHeader.vue";
import ExaminationMediaTable from "./ExaminationMediaTable.vue";
import ExaminationCaseDataBox from "./ExaminationCaseDataBox.vue";
import ExaminationManifestBox from "./ExaminationManifestBox.vue";

export default {
  name: "ExaminationDetailModal",
  components: {
    ExaminationHeader: ExaminationHeader,
    ExaminationMediaTable: ExaminationMediaTable,
    ExaminationCaseDataBox: ExaminationCaseDataBox,
    ExaminationManifestBox: ExaminationManifestBox,
  },
  props: { examinationId: { type: [String, Number], required: true } },
  data() {
    return { loading: true, error: "", data: null, expanded: {} };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.error = "";
      practitionerHttpService
        .get(`/api/internal/admin/logs/examinations/${this.examinationId}`)
        .then((res) => {
          this.data =
            res && typeof res === "object" && "data" in res ? res.data : res;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.error = error?.message || "Failed to load";
          if (this.userErrorMessage) this.userErrorMessage(error);
        });
    },
    refresh() {
      this.fetchData();
    },
    toggle(id) {
      this.expanded = { ...this.expanded, [id]: !this.expanded[id] };
    },
  },
};
</script>

<style>
.modal {
  z-index: 1060;
}
.modal-backdrop {
  z-index: 1050;
}
.modal-dialog.wide-modal {
  --bs-modal-width: calc(100vw - 1.25rem);
  max-width: 1400px;
}
.modal-content {
  max-height: calc(100vh - 1rem);
  display: flex;
  flex-direction: column;
}
.modal-body {
  overflow: auto;
}
.modal-footer {
  border-top: none;
}
.sticky-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  z-index: 1;
}
</style>
<style src="./css/draftExaminationDetail.css"></style>
